@if (visible && (dialogProperties$ | async); as dialogProperties) {
  <bd-dialog
    data-id="delete-population-dialog"
    [visible]="visible"
    (dismiss)="cancel()"
    [dialogProperties]="dialogProperties"
    *transloco="let t; scope: 'featurePopulations'"
  >
    <div class="h-full">
      <p
        data-id="delete-warning-message"
        class="bd-population-dialog-label"
        [innerHTML]="
          t('featurePopulations.deletePopulationModal.warningMessage', {
            populationName: population.name.bold(),
          })
        "
      ></p>
      <div
        data-id="delete-population-content"
        class="bd-population-dialog-label my-4"
      >
        @if (loading) {
          <div class="mt-4">
            <p-skeleton
              data-id="delete-population-skeleton-large"
              width="20rem"
              class="mb-2"
            ></p-skeleton>
            <p-skeleton
              data-id="delete-population-skeleton-small"
              width="9rem"
              class="mb-2"
            ></p-skeleton>
          </div>
        } @else {
          @if (usedInFrames.length > 0) {
            <p
              data-id="delete-used-population-message"
              class="my-4"
              [innerHTML]="
                t('featurePopulations.deletePopulationModal.usedFrameMessage', {
                  populationNumber: usedInFrames.length.toString().bold(),
                })
              "
            ></p>
            <div
              data-id="delete-frame-used-list"
              class="bd-frame-list flex flex-col overflow-y-scroll gap-y-4 h-[136px]"
            >
              @for (usedInFrame of usedInFrames; track usedInFrame.id) {
                <p-button
                  [attr.data-id]="'frame-used-' + usedInFrame.id"
                  [link]="true"
                  styleClass="bd-neutral bd-no-capitalize"
                  icon="ui-new-tab"
                  [label]="
                    usedInFrame.name + ' - ' + usedInFrame.workspace.name
                  "
                  [pTooltip]="
                    t(
                      'featurePopulations.deletePopulationModal.usedFrameTooltip'
                    )
                  "
                  tooltipPosition="top"
                >
                </p-button>
              }
            </div>
          } @else {
            {{
              t('featurePopulations.deletePopulationModal.unusedFrameMessage')
            }}
          }
        }
      </div>
    </div>
    <div class="flex gap-x-4 justify-end" footer>
      <p-button
        styleClass="bd-neutral"
        data-id="cancel-delete-population-btn"
        [outlined]="true"
        [label]="t('featurePopulations.deletePopulationModal.cancelBtn')"
        (onClick)="cancel()"
      ></p-button>
      <p-button
        styleClass="bd-danger"
        data-id="delete-population-btn"
        [label]="t('featurePopulations.deletePopulationModal.deleteBtn')"
        (onClick)="delete()"
      ></p-button>
    </div>
  </bd-dialog>
}
